import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "@boxicons/react";
import { Community } from "@boxicons/react";
import { Images } from "@boxicons/react";
import { Spanner } from "@boxicons/react";
import { Face } from "@boxicons/react";
import { ContactBook } from "@boxicons/react";

const EmainNav = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    // Redirige al componente específico
    navigate('/');  // Aquí reemplaza con la ruta a tu componente
  };
    useEffect(() => {
        const scrollMenu = () => {
          const header = document.querySelector('nav');
          const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
          if (scrollPosition > 20) {
            header.classList.add('tinted');
          } else {
            header.classList.remove('tinted');
          }
        };
    
        window.addEventListener('scroll', scrollMenu);
    
        return () => {
          window.removeEventListener('scroll', scrollMenu); // Limpia el evento cuando el componente se desmonte
        };
      }, []);

      const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      };
    return(
        <nav>
            <div className="logo" onClick={() => scrollToSection('beginning')}>
                <img src='/images/logos/logoHome.png' width={50} alt="logo ABP"></img>
            </div>
            <div className="nav-buttons" onClick={() => scrollToSection('beginning')}>
                <Home pack="filled" fill="#fff" className="i-nav"/>
                <p>Beginning</p>
            </div>
            <div className="nav-buttons" onClick={() => scrollToSection('about')}>
                <Community pack="filled" fill="#fff"  className="i-nav"></Community>
                <p>Us</p>
            </div>
            <div className="nav-buttons" onClick={() => scrollToSection('gallery')}>
                <Images pack="filled" fill="#fff" className="i-nav"></Images>
                <p>Gallery</p>
            </div>
            <div className="nav-buttons" onClick={() => scrollToSection('works')}>
                <Spanner pack="filled" fill="#fff" className="i-nav"/>
                <p>Services</p>
            </div>
            <div className="nav-buttons" onClick={() => scrollToSection('clients')}>
                <Face pack="filled" fill="#fff" className="i-nav"/>
                <p>Costumers</p>
            </div>
            <div className="nav-buttons" onClick={() => scrollToSection('footer')}>
                <ContactBook pack="filled" fill="#fff" className="i-nav"/>
                <p>Contact</p>
            </div>
            <div className="nav-buttons" onClick={handleClick}>
                <p>Español</p>
            </div>
        </nav>
    )
}
export default EmainNav;

